import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { CheckAccountDto } from './guest-to-master-repository.interface';
import { CheckAccountModel } from '../model/check-account-model.interface';
import type { GuestToMasterService } from './guest-to-master-service.interface';
import type { CheckAccount } from '../type';

@injectable()
export class GuestToMasterServiceImpl implements GuestToMasterService {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    @inject(CheckAccountModel) private _checkAccountModel: CheckAccountModel,
    @inject(CheckAccountDto) private _checkAccountDto: CheckAccountDto,
  ) {}

  async checkAccount(email: string, isLogin: boolean): Promise<CheckAccount> {
    const checkAccount = await this._checkAccountDto.checkAccount(email, isLogin);
    this._checkAccountModel.update(() => checkAccount);
    return checkAccount;
  }
}
